export default function createRequest(apiRequest: $TSFixMe, baseUrl: string) {
    return function request(url: string, ...args: $TSFixMe[]) {
        return apiRequest(baseUrl + url, ...args);
    };
}
